import { api } from './api';

export const sellerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSellerById: builder.query({
      query: (id) => `/sellers/${id}`,
      providesTags: ['Seller'],
    }),

    updateSeller: builder.mutation({
      query: ({ id, body }) => ({
        url: `/sellers/${id}`,
        method: 'PUT',
        body,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Seller'],
    }),
  }),
});

export const { useGetSellerByIdQuery, useUpdateSellerMutation } = sellerApi;
